<template>
  <div class="achievement_detail">
    <div class="breadcrumb">
      <div class="m">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/achievement'}">成果中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{params.name}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="a">
      <div class="m">
        <div class="a_l">
          <img v-lazy="params.coverPath" alt />
        </div>
        <div class="a_r">
          <h2>
            <span>{{params.name}}</span>
            <div class @click="collect" v-if="!params.isCollection">
              <i class="el-icon-star-off"></i>收藏
            </div>
            <div class @click="cancelCollect" v-else>
              <i class="el-icon-star-on"></i>已收藏
            </div>
          </h2>
          <div class="b">
            <div class="b_a first">
              <div class="b_a_l">价格：</div>
              <div class="b_a_r">￥38200</div>
            </div>
            <div class="b_a second">
              <div class="b_a_l">促销价：</div>
              <div class="b_a_r">
                <span>￥</span>
                {{params.price||'面议'}}
              </div>
            </div>
          </div>
          <div class="c">
            <ul class="c_l">
              <li>
                <div class="lab">技术领域:</div>
                {{common.filterHtml(params.field_Name)}}
              </li>
              <li>
                <div class="lab">先进性:</div>
                {{common.filterHtml(params.advanced_name)}}
              </li>
              <li>
                <div class="lab">转让形式:</div>
                {{common.filterHtml(params.cooperation_name)}}
              </li>
              <li>
                <div class="lab">人气:</div>
                {{common.filterHtml(params.popularity)}}
              </li>
            </ul>
            <ul class="c_r">
              <li>
                <div class="lab">可应用行业:</div>
                {{common.filterHtml(params.industry)}}
              </li>
              <li>
                <div class="lab">所处阶段:</div>
                {{common.filterHtml(params.stage_name)}}
              </li>
              <li>
                <div class="lab">成果类型:</div>
                {{common.filterHtml(params.type_name)}}
              </li>
              <li>
                <div class="lab">应用情况:</div>
                {{common.filterHtml(params.situation)}}
              </li>
            </ul>
          </div>
          <a
            class="btn"
            href="javascript:;"
            @click="buttJoint"
          >帮我对接</a>
        </div>
      </div>
    </div>
    <!-- 详情内容 -->
    <div class="detail_tabs">
      <!-- tab切换按钮 -->
      <div class="detail_tabs_t">
        <div :class="['tabs m',{fixed:is_fixed}]">
          <div :class="['tab_item',{is_active:tabsIndex===0}]" @click="tabsSwitchover(0)">成果详情</div>
          <div :class="['tab_item',{is_active:tabsIndex===1}]" @click="tabsSwitchover(1)">荣誉简介</div>
          <div :class="['tab_item',{is_active:tabsIndex===2}]" @click="tabsSwitchover(2)">市场分析</div>
          <div :class="['tab_item',{is_active:tabsIndex===3}]" @click="tabsSwitchover(3)">交易流程</div>
          <div
            :class="['tab_item',{is_active:tabsIndex===4}]"
            @click="tabsSwitchover(4)"
          >浏览记录({{layerpageinfo.total}})</div>
        </div>
      </div>
      <!-- 内容展示 -->
      <div class="detail_tabs_content m">
        <div class="synopsis ck-text">
          <h4>成果详情</h4>
          <div v-html="params.synopsis||'暂无'"></div>
        </div>
        <div class="synopsis ck-text">
          <h4>荣誉简介</h4>
          <div v-html="params.honor||'暂无'"></div>
        </div>
        <div class="synopsis ck-text">
          <h4>市场分析</h4>
          <div v-html="params.market_analysis||'暂无'"></div>
        </div>
        <div class="trade_process_con">
          <h4>交易流程</h4>
          <tradeFlow :trade_flow="trade_flow"></tradeFlow>
        </div>
        <div class="synopsis">
          <h4>浏览记录</h4>
          <div class="record_box" v-infinite-scroll="load" style="overflow-y:auto">
            <div class="record_item" v-for="item in messages">
              <img
                v-lazy="item.userHeadPath ? item.userHeadPath :'https://sctcc-applet.oss-cn-shenzhen.aliyuncs.com/hz_space_star/img/default.png'"
                alt
              />
              <div class="record">
                <p>{{item.content}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tradeFlow from "../components/trade_flow.vue";
export default {
  components: {
    tradeFlow
  },
  data() {
    return {
      params: {},
      images: [], //图片列表
      trade_flow: [
        //交易流程
        {
          name: "提交需求",
          content: "在华转网重大科技成果库中选择成果下单，或提交需求单。"
        },
        { name: "业务对接", content: "平台业务经理进行需求确认并接单。" },
        {
          name: "精确匹配",
          content: "平台通过需求库、技术经纪人队伍，进行精准匹配。"
        },
        {
          name: "初步对接",
          content:
            "平台组织双方双向线下交流或考察，按需组织评估，确定对接方案。"
        },
        {
          name: "服务执行",
          content: "业务经理配合双方按照服务方案进行成果转化，全程跟进服务。"
        },
        {
          name: "双方评价",
          content: "平台对服务方、需求发、技术经纪人进行诚信管理。"
        }
      ],
      is_fixed: false,
      tabsTop: 0,
      tabsIndex: 0,
      detailList: [],
      messages: [],
      layerpageinfo: {
        pageNo: 1,
        total: 0,
        pageSize: 10
      }
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      this.tabFixed();
    });
  },
  methods: {
    //加载更多
    load() {
      if (!this.params.code) return;
      if (
        this.layerpageinfo.pageNo * this.layerpageinfo.pageSize >=
          this.layerpageinfo.total &&
        this.layerpageinfo.total != 0
      )
        return;
      this.layerpageinfo.pageNo++;
      this.getBrowsingHistory();
    },
    //查询浏览记录
    getBrowsingHistory() {
      let params = Object.assign({}, this.layerpageinfo, {
        type: "MessageTypeCG",
        code: this.params.code
      });
      this.api.getMessages(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let list = res.obj.list;
        this.messages.push(...list);
        this.layerpageinfo.total = res.obj.totalSize;
      });
    },
    getData() {
      let params = {
        id: this.$route.query.id,
        collection: sessionStorage.getItem("loginKey"), //是否收藏了
        loginKey: sessionStorage.getItem("loginKey")
      };
      this.api.getAchievements(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let list = res.obj.list[0];
        //关键字分割
        list.keyword =
          res.obj.list[0].keyword && res.obj.list[0].keyword.indexOf(",") !== -1
            ? res.obj.list[0].keyword.split(",")
            : [];
        list.keyword =
          res.obj.list[0].keyword &&
          res.obj.list[0].keyword.indexOf("，") !== -1
            ? res.obj.list[0].keyword.split("，")
            : [];
        list.keyword =
          res.obj.list[0].keyword &&
          res.obj.list[0].keyword.indexOf("、") !== -1
            ? res.obj.list[0].keyword.split("、")
            : [];
        list.keyword =
          res.obj.list[0].keyword &&
          res.obj.list[0].keyword.indexOf("；") !== -1
            ? res.obj.list[0].keyword.split("；")
            : [];
        //图片数组分割
        res.obj.list[0].coverPath
          ? this.images.push(res.obj.list[0].coverPath)
          : "";
        let images = res.obj.list[0].image_detailsPath
          ? res.obj.list[0].image_detailsPath.split("|")
          : [];
        this.images = [...this.images, ...images];

        this.params = list;
        //获取浏览记录
        this.getBrowsingHistory();
      });
    },
    //收藏
    collect() {
      let params = {
        user_id: this.info.id,
        achievement: this.$route.query.id,
        loginKey: sessionStorage.getItem("loginKey")
      };
      this.api.createUserAchievement(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.params.isCollection = true;
        this.$message({
          type: "success",
          message: "收藏成功"
        });
      });
    },
    //取消收藏
    cancelCollect() {
      this.api
        .getUserAchievements({
          achievement: this.$route.query.id,
          loginKey: sessionStorage.getItem("loginKey")
        })
        .then(res => {
          if (res.error["err_code"] !== 0) return;
          if (res.obj.list[0]) {
            this.cancelUserCollect(res.obj.list[0].id);
          }
        });
    },
    cancelUserCollect(id) {
      let params = {
        ids: id,
        loginKey: sessionStorage.getItem("loginKey")
      };
      this.api.deleteUserAchievement(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.params.isCollection = false;
        this.$message({
          type: "success",
          message: "已取消收藏"
        });
      });
    },
    /** 对接*/
    buttJoint() {
      //如果用户id为空
      if (!sessionStorage.getItem("user_id")) {
        this.$message.info("请先登录");
        this.$router.push({ path: "/login" });
        return;
      }
      //用户名 或者用户手机为空
      if (!this.info.mobile) {
        this.$message.info("请完善个人信息");
        return;
      }
      this.$confirm("确定要对接该商品？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success"
      }).then(() => {
        this.cerateOrder();
      });
    },
    /** 创建订单*/
    cerateOrder() {
      let params = {
        type: "ServiceTypeAchievement", //业务类型
        status: "OrderStatusWaiting", //订单状态
        user_id: sessionStorage.getItem("user_id"), //用户id
        user_sale_id: this.params.user_id, //卖家id
        name: this.params.name, //订单名称
        cover: this.params.coverId, //订单封面
        entity_id: this.params.id, //关联商品id
        entity_code: this.params.code, //关联商品code
        link: this.$route.fullPath, //当前页面路径
        contact: this.info.name ? this.info.name : this.info.user_name, //联系人姓名
        contact_phone: this.info.mobile ? this.info.mobile : "", //联系人电话
        contact_email: this.info.email ? this.info.email : "", //联系人邮箱
        active: true,
        loginKey: sessionStorage.getItem("loginKey")
      };
      this.api.schoolClassSignUp(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.$message.success("已提交对接需求，可在订单中查看最新状态");
      });
    },
    /** 点击tab到指定位置*/
    tabsSwitchover(index) {
      this.getTopList();
      this.tabsIndex = index;
      window.scrollTo(0, this.detailList[index] - 47);
    },
    /** 获取元素距离顶部的的位置  列表*/
    getTopList() {
      this.detailList = [];
      document
        .querySelectorAll(".detail_tabs_content>div")
        .forEach((item, i) => {
          this.detailList.push(item.offsetTop); //详情内容的位置
          // console.log(item.offsetTop)
        });
    },
    tabFixed() {
      //tabs 距离可视区域最顶部的高
      this.tabsTop = document.querySelector(".tabs").offsetTop;
      // 开启滚动监听
      window.addEventListener("scroll", () => {
        this.getTopList();
        let scrollbarWidth = this.common.getScrollbarWidth();
        if (document.documentElement.scrollTop >= this.tabsTop) {
          this.is_fixed = true;
          document.querySelector(".tabs").style.left = scrollbarWidth + "px";
        } else {
          this.is_fixed = false;
        }

        this.detailList.forEach((item, i) => {
          if (
            document.documentElement.scrollTop >= item - 47 &&
            document.documentElement.scrollTop < this.detailList[i + 1]
          ) {
            this.tabsIndex = i;
          }
        });
      });
    },
    
  }
};
</script>

<style lang="scss" scoped>
.achievement_detail {
  .breadcrumb {
    padding: 18px 0;
  }
  .a {
    .m {
      width: 1200px;
      height: 438px;
      background: #ffffff;
      border-radius: 4px;
      padding: 30px 30px 0;
      box-sizing: border-box;
      display: flex;
      .a_l {
        width: 90px;
        img {
          width: 90px;
          height: 90px;
          border-radius: 4px;
          object-fit: cover;
          object-position: center;
          background: #f0f0f0;
        }
      }
      .a_r {
        margin-left: 30px;
        h2 {
          padding: 9px 0 29px;
          display: flex;
          justify-content: space-between;
          span {
            font-size: 20px;
            color: #343434;
          }
          & > div {
            cursor: pointer;
          }
        }
        .b {
          width: 700px;
          height: 100px;
          padding: 24px 21px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          background: #f0f0f0;
          .b_a {
            display: flex;
            align-items: center;
            .b_a_l {
              font-size: 14px;
              color: #666666;
            }
            .b_a_r {
              font-size: 14px;
              color: #666666;
              span {
              }
            }
          }
          .first.b_a {
            .b_a_r {
              text-decoration: line-through;
            }
          }
          .second.b_a {
            .b_a_r {
              font-size: 24px;
              color: #ff4e5a;
              span {
                font-size: 14px;
              }
            }
          }
        }
        .c {
          display: flex;
          margin-top: 16px;
          .c_l,
          .c_r {
            li {
              display: flex;
              color: #343434;
              font-size: 14px;
              line-height: 28px;
              .lab {
                color: #9a9a9a;
                min-width: 110px;
              }
            }
          }
          .c_l{
            max-width: 50%;
          }
          .c_r {
            margin-left: 90px;
            max-width: 50%;
          }
        }
        .btn {
          display: inline-block;
          width: 180px;
          height: 44px;
          text-align: center;
          line-height: 44px;
          background: #4c84ff;
          border-radius: 4px;
          font-size: 18px;
          color: #f0f2f5;
          margin-top: 16px;
        }
      }
    }
  }
  //详情内容
  .detail_tabs {
    margin-top: 20px;
    padding-bottom: 20px;
    .tabs {
      height: 60px;
      background-color: #fff;
      box-sizing: border-box;
      display: flex;
  
      .tab_item {
        line-height: 60px;
        padding: 0 25px;
        font-size: 14px;
        color: #666;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
      }

      .tab_item.is_active::after {
        content: "";
        position: absolute;
        bottom: 0;
        width: 56px;
        height: 2px;
        background: #4c84ff;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
    }

    //tabs固定顶部
    .tabs.fixed {
      position: fixed;
      top: 0px;
      left: 0;
      right: 0px;
      margin: 0 auto;
      z-index: 9999;
    }
    .detail_tabs_content {
      background: #fff;
      padding: 30px 20px;
      box-sizing: border-box;
      & > div {
        padding: 0 0 20px 0;
        line-height: 26px !important;
        & > h4 {
          font-weight: bold;
          position: relative;
          font-size: 16px;
          height: 34px;
          line-height: 34px;
          color: #343434;
          margin: 0 !important;
        }
        & > div {
          padding: 0 20px;
          box-sizing: border-box;
          color: #9fa4b1;
        }
      }
      .synopsis {
        & > div {
          color: #9fa4b1;
          line-height: 26px !important;
          padding: 0 20px;
        }
      }
    }

    //交易流程
    .trade_process_con {
      width: 100%;
      height: 240px;
      display: flex;
      flex-direction: column;
    }
  }
  /* 浏览记录 */
  .record_box {
    padding: 30px 20px;
    max-height: 260px;
    .record_item {
      display: flex;
      margin-bottom: 30px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 20px;
      }
      .record {
        display: flex;
        align-items: center;
      }
    }
  }
  .record_box::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .record_box::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    /*box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);*/
    background: #aaaaaa;
  }
  .record_box::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    /*box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);*/
    border-radius: 10px;
    background: #f5f5f5;
  }
}
</style>